export default __webpack_public_path__ + "static/media/preview-es.09a0c4dc.png";